import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import UserDocumentsAdmin from "./UserDocumentsAdmin";

export default function UsersAdmin() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const [openId, setOpenId] = useState(null);

  const load = useCallback(() => {
    api.get("/admin/users", { params: { q } }).then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, [q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  const remove = async (u) => {
    if (!window.confirm(`¿Borrar la cuenta de ${u.name}? También se quitan sus documentos.`)) return;
    try { await api.delete(`/admin/users/${u.id}`); toast.success("Usuario borrado"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="users-admin" className="space-y-5">
      <input data-testid="users-search" className="input-field max-w-md" placeholder="Buscar por nombre o correo"
        value={q} onChange={(e) => setQ(e.target.value)} />
      {!items ? <p className="text-zinc-500 text-sm">Cargando…</p> : !items.length ? (
        <p data-testid="users-empty" className="text-zinc-500">Aún no hay usuarios registrados.</p>
      ) : items.map((u) => (
        <div key={u.id} data-testid={`user-row-${u.id}`} className="card !p-5">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <p className="text-white text-lg">{u.name}
                {!u.verified && <span className="ml-3 overline !text-amber-400">Sin confirmar</span>}</p>
              <p className="text-sm text-zinc-400">{u.email}</p>
              <p className="text-xs text-zinc-500 mt-1">
                {u.birth ? `${u.birth.birth_date} · ${u.birth.birth_time} · ${u.birth.birth_place}` : "Sin datos natales"}
                {" · "}Registro {u.created_at?.slice(0, 10)} · {u.documents} documento(s)
              </p>
            </div>
            <div className="flex gap-2">
              <button data-testid={`user-docs-${u.id}`} onClick={() => setOpenId(openId === u.id ? null : u.id)}
                className="btn-ghost !py-2 !px-3 text-xs">{openId === u.id ? "Cerrar" : "Documentos"}</button>
              <button data-testid={`user-delete-${u.id}`} onClick={() => remove(u)}
                className="btn-ghost !py-2 !px-3 text-xs hover:!text-red-400">Borrar</button>
            </div>
          </div>
          {openId === u.id && <UserDocumentsAdmin userId={u.id} onChange={load} />}
        </div>
      ))}
    </div>
  );
}
